export default "__VITE_ASSET__BUYnEIeI__"